import {Base} from "@/api/Base"

export class OtherList extends Base {
    path = "other/list"
}